import axios from './_defaults/api';

export async function getLocations({params}) {
    try {
        const response = await axios.get("/locations", {params});
        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function getLocation({locationId}) {
    try {
        const response = await axios.get(`/locations/${locationId}`);
        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function createLocation({data}) {
    try {
        const response = await axios.post(`/locations`, data);
        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function updateLocation({locationId, data}) {
    try {
        const response = await axios.post(`/locations/${locationId}`, data);
        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export async function removeLocation({locationId}) {
    try {
        const response = await axios.delete(`/locations/${locationId}`);
        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}